/**
 * Expand and collapse elements
 * @module app/components/BodyStateAdapter
 */
import jQuery from 'jquery';

var $body = jQuery('body');

/**
 * Public functions.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Sets up drop Down / toggle menus
     *
     * @param jQuery jQuery
     * @param page Page
     * @param sport Sport
     *
     * @returns {void}
     *
     * @public
     */
    init: function (jQuery, page, sport) {
        $body.attr('data-page', page);
        $body.attr('data-sport', sport);
    },

    /**
     * Toggles scrolling on the body element
     *
     * @param disable
     *
     * @returns {void}
     *
     * @public
     */
    toggleBodyScrolling: function toggleBodyScrolling(disable) {

        $body.toggleClass('-unscrollable', disable);

    },
};

export default api;
